import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import Navbar from '../../components/Navbar';

// Module placement for the admin panel — cip_admin sees all platform tools.
const NAV = [
  { to: '/dashboard',   label: 'Dashboard' },
  { to: '/coms',        label: '💬 Coms Hub' },
  { to: '/admin/connector', label: '⚙️ Connector Config' },
  { to: '/admin',       label: 'Tenants & Users' },
  { to: '/assessments', label: 'Assessments' },
  { to: '/reports',     label: 'Reports' },
  { to: '/pipeline',    label: 'Pipeline' },
  { to: '/lenses',            label: '🔭 Lenses' },
  { to: '/seven-gen',         label: '🏹 7-Gen Planning' },
  { to: '/land-intelligence', label: '🌐 Land Intelligence' },
  { to: '/land-units',        label: '🗻 Land Units' },
];

const AdminShell = () => (
  <div className="shell shell--admin">
    <Navbar />
    <div className="shell-body">
      <nav className="shell-sidenav" aria-label="Admin navigation">
        <span className="shell-sidenav__heading">Platform Admin</span>
        <ul>
          {NAV.map(({ to, label }) => (
            <li key={to}>
              <NavLink
                to={to}
                className={({ isActive }) =>
                  isActive ? 'shell-sidenav__link shell-sidenav__link--active' : 'shell-sidenav__link'
                }
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <main className="shell-content">
        <Outlet />
      </main>
    </div>
  </div>
);

export default AdminShell;
